import Moment from 'moment'
import {momentRange} from "../convert/moment-range"
import utcDatetimeToMoment from "./datetime/utc-datetime-to-moment"

// Depricated - use utils/datetime/functions

const DatetimeUtils = {

    dateToMoment(yyyymmdd:string|Moment):Moment {
        if (!yyyymmdd) {
            // @ts-ignore
            return null;
        }

        // must reconvert to moment otherwise issues at least in workload ....
        if (Moment.isMoment(yyyymmdd)) return moment(yyyymmdd)

        return moment(yyyymmdd)
    },

    // Convert URL datatime string into Moment with LOCAL timezone !!!!!
    datetimeToMoment(datetime:string):Moment {
        // @ts-ignore
        if (!datetime) return null;
        return utcDatetimeToMoment(datetime);
    },

    momentTruncTime(moment:Moment):Moment {
        // @ts-ignore
        return DatetimeUtils.dateToMoment(DatetimeUtils.momentToDate(moment));
    },

    dateTruncTime(date:any) {
        return DatetimeUtils.momentToDate(DatetimeUtils.dateToMoment(date));
    },

    momentToUTCISODatetime(moment:Moment | null):string | null {
        if (!moment) return null;
        return Moment(moment).utc().format();
    },

    momentFromString(timeString:string) {
        const getHours = (number:number) : number => number < 24 ? number : 23 // if value is more than 23 then set 23 hours
        const getMinutes = (number:number) : number => number < 60 ? number : 59 // if value is more than 59 then set 59 minutes

        const regexp2 = new RegExp(/(\d*).*?([AaPp])?/, 'gmis');
        const matches = [...timeString.matchAll(regexp2)];

        // collect all matched hours, minutes and meridiem any
        let hours : number | '' = ''
        let minutes : number | '' = ''
        let meridiem = ''

        _.map(matches, match=>{
            if (match[0]) {
                if ('aApP'.includes(match[0]) && !meridiem) {
                    if (!!hours) meridiem = match[0] === 'p' ? 'pm' : 'am'; // no meridiem if hours are not yet set
                } else {
                    const matchedString = match[0].length > 2 ? match[0].slice(0,2) : match[0]; // get only first two digits
                    const number = parseInt(matchedString);

                    if (!hours)         hours = getHours(number);
                    else if (!minutes)  minutes = getMinutes(number);
                }
            }
        });


        return {
            moment: hours && minutes ? Moment('{0} {1}:{2} {3}'.f(this.momentToDate(Moment()), hours, minutes, meridiem)) : null,
            hours,
            minutes,
            meridiem
        }
    },

    isWeekend(moment:Moment):boolean {
        return moment.day() === 0 || moment.day() === 6;
    },

    // use to format to Y-M-d format when call api
    momentToDate(moment?:Moment|null):string|null {
        if (moment) return moment.format("YYYY-MM-DD");
        else return null;
    },

    // TODO
    // formatDateShort(moment) {
    //     const format = _.get(gd.session, 'me.formatSettings.date','DD MMM, YYYY');
    // },

    get shortDateFormat() {
        return _.get(gd.session, 'me.formatSettings.date','DD MMM, YYYY');
    },

    get weekStart() {
        // mon-sun lower case
        return _.get(gd.session, 'me.formatSettings.weekStart','mon');
    },

    get weekStartNumber():number {
        switch (this.weekStart) {
            case 'sun': return 0;
            case 'mon': return 1;
            case 'tue': return 2;
            case 'wed': return 3;
            case 'thu': return 4;
            case 'fri': return 5;
            case 'sat': return 6;

            // just in case and TS
            default:
                return 1
        }
    },

    // give any moment and result is moment.range() accoriding to the sytem week start date
    getWeekDaterangeByDate(moment:Moment, considerTime = false):DateRange {

        let shift = 0;

        while (moment.clone().subtract(shift, 'days').format('ddd').toLowerCase() !== this.weekStart && shift<7) {
            shift++;
        }

        let firstDateOfWeek = moment.clone().subtract(shift,'days')
        let lastDayOfWeek   = firstDateOfWeek.clone().add(6,'days')

        if (considerTime) {
            firstDateOfWeek = firstDateOfWeek.startOf('day')
            lastDayOfWeek   = lastDayOfWeek.endOf('day')
        }

        // return Moment.range(firstDateOfWeek, lastDayOfWeek)
        return momentRange(firstDateOfWeek, lastDayOfWeek)
    },


    // determine first date we need to show to align with "weekStart"
    calendarMonthViewFirstDate(currentMonth:Moment) {

        let shift = 0;
        const startOfMonth = currentMonth.startOf('month');

        while (startOfMonth.clone().subtract(shift, 'days').format('ddd').toLowerCase() !== this.weekStart && shift<7) {
            // console.log(0, startOfMonth.clone().subtract(shift, 'days').format('ddd').toLowerCase());
            shift++;
        }

        const startOfCalendar = startOfMonth.clone().subtract(shift,'days');

        // console.log("month starts on", startOfMonth.format("MMM DD - ddd"));
        // console.log("users first dow is", this.weekStart);
        // console.log("SHIFT=", shift);
        // console.log("first day in calendar should be", startOfCalendar.format("MMM DD - ddd"));

        return startOfCalendar;

    },

    isSame(moment1:Moment|null, moment2:Moment|null, granularity:'day' = 'day') {
        return (!moment1 && !moment2) ||
            (!!moment1 && !!moment2 && moment1.isSame(moment2, granularity))
    },

    isBeforeToday(value: Moment | null):boolean {

        if (!value) return false   // if no moment passed always false

        if (!Moment.isMoment(value)) value = moment(value)

        return value.isBefore(moment(),'days');
    },

    stickToSteps(value:any, minStep:number = 15 /*minutes*/) {
        const startOfHour = moment(value).startOf('hour');
        const minutesDiff = value.diff(startOfHour, 'minutes');
        const steps = Math.floor(minutesDiff / minStep);

        return startOfHour.add(minStep * steps, 'minutes');
    },

    setTime(date:any, time:Moment){return Moment(date).hours(time.hours()).minutes(time.minutes()).seconds(time.seconds())},

    // used to clear time values for example for days range calculation
    // moment1.diff(moment2, 'days') calculates FULL days between dates, so even 1 second difference may cause -1 day in result
    normalizeDateMoment(moment:any) {
        if (!moment) return null
        return Moment(moment.format("YYYY-MM-DD"))
    },

    getCalendarDateRangeByMonth(startDate:Moment):any {

        // const start : Moment = moment(startDate).startOf('month').subtract(2,'week')
        // const end   : Moment = moment(startDate).endOf('month').add(2,'weeks')
        //
        // return momentRange(start, end)

        return {
            start:  moment(startDate).startOf('month').subtract(2,'week'),
            end:    moment(startDate).endOf('month').add(2,'weeks')
        }
    }
};

export default DatetimeUtils;
